// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__suH3h","header":"ClearentDisclaimer_header__1AEOr","inner":"ClearentDisclaimer_inner__3Jbj9"};